import React from "react";
import MuiSelect from "@mui/material/Select";
import ExpandMoreSharpIcon from "@mui/icons-material/ExpandMoreSharp";

const Select = ({ children, ...rest }) => (
  <MuiSelect IconComponent={ExpandMoreSharpIcon} {...rest}>
    {children}
  </MuiSelect>
);

export default Select;
